import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function IntroSection() {
  return <div className="grid md:grid-cols-12 gap-12 mb-16" data-id="element-456">
      {/* Left Column (55%) */}
      <div className="md:col-span-7 space-y-8" data-id="element-457">
        <div className="flex justify-center md:justify-start" data-id="element-458">
          <a href="https://www.bodor.com/us/" target="_blank" rel="noopener noreferrer" className="inline-block bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-459">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Bodor%20Laser%20Logo.png800x800.png" alt="Bodor Laser Logo" className="block h-16 md:h-20 w-auto" data-id="element-460" />
          </a>
        </div>

        <div className="bg-gray-50 rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-461">
          <h3 className="font-bold text-[#002d4d] text-lg mb-4" data-id="element-462">
            Featured Videos
          </h3>
          <div className="space-y-4" data-id="element-463">
            <a href="https://www.linkedin.com/posts/jinan-bodor-cnc-machine-co-ltd_bodor-laser-cutting-activity-6783645141715550208-Uhyd" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-white p-3 rounded-lg transition-colors group border border-transparent hover:border-gray-200 hover:shadow-sm" data-id="element-464">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-465" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors font-medium" data-id="element-466">
                Bodor 12kw laser cutting 30mm(1.18") carbon steel
              </span>
            </a>
            <a href="https://youtu.be/E8NbjV9GxEw" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-white p-3 rounded-lg transition-colors group border border-transparent hover:border-gray-200 hover:shadow-sm" data-id="element-467">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-468" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors font-medium" data-id="element-469">
                Bodor 40kW Laser Cutting Machine
              </span>
            </a>
            <a href="https://youtu.be/ZLPCopB0br0" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-white p-3 rounded-lg transition-colors group border border-transparent hover:border-gray-200 hover:shadow-sm" data-id="element-470">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-471" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors font-medium" data-id="element-472">
                BodorGenius Ultra-High Power Laser Head
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Right Column (45%) */}
      <div className="md:col-span-5 flex flex-col justify-center" data-id="element-473">
        <div className="mb-8 flex justify-center" data-id="element-474">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Plate-cutting%20fiber%20laser.png800x800.png" alt="Plate cutting fiber laser" className="block max-w-full h-auto object-contain max-h-64 drop-shadow-xl" data-id="element-475" />
        </div>

        <div className="bg-white rounded-xl p-6 border-l-4 border-[#f5693d] shadow-md" data-id="element-476">
          <h3 className="text-xl font-bold text-[#002d4d] mb-4" data-id="element-477">Highlights:</h3>
          <ul className="space-y-3" data-id="element-478">
            <li className="flex items-start" data-id="element-479">
              <span className="text-[#f5693d] mr-2 mt-1" data-id="element-480">•</span>
              <span className="text-gray-700" data-id="element-481">
                Fiber Laser Sheet &amp; Tube Cutting
              </span>
            </li>
            <li className="flex items-start" data-id="element-482">
              <span className="text-[#f5693d] mr-2 mt-1" data-id="element-483">•</span>
              <span className="text-gray-700" data-id="element-484">
                1kW—40kW—Highest Power Fiber Laser—Cut up to 8" thick
              </span>
            </li>
            <li className="flex items-start" data-id="element-485">
              <span className="text-[#f5693d] mr-2 mt-1" data-id="element-486">•</span>
              <span className="text-gray-700" data-id="element-487">European quality</span>
            </li>
            <li className="flex items-start" data-id="element-488">
              <span className="text-[#f5693d] mr-2 mt-1" data-id="element-489">•</span>
              <span className="text-gray-700" data-id="element-490">
                Integrated Automation Solutions
              </span>
            </li>
            <li className="flex items-start" data-id="element-491">
              <span className="text-[#f5693d] mr-2 mt-1" data-id="element-492">•</span>
              <span className="text-gray-700" data-id="element-493">
                <strong className="text-[#f5693d]" data-id="element-494">BEST Pricing</strong>{' '}
                <strong data-id="element-495">in the Industry</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>;
}